/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PublicationWithRelations } from '../../models/publication-with-relations';

export interface InventoryGetPublications$Params {
  inventoryId: string;
}

export function inventoryGetPublications(http: HttpClient, rootUrl: string, params: InventoryGetPublications$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PublicationWithRelations>>> {
  const rb = new RequestBuilder(rootUrl, inventoryGetPublications.PATH, 'get');
  if (params) {
    rb.query('inventoryId', params.inventoryId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PublicationWithRelations>>;
    })
  );
}

inventoryGetPublications.PATH = '/inventory/publications';
